"use client";

import { c as _c } from "react/compiler-runtime";
import { ExpandableToggle, type ToggleOption } from "@/components/common/expandable-toggle";
import { useCurrentCityName } from "@/hooks/use-current-city";
import { useSearchMode } from "@/hooks/use-search-mode";
import { ListFilterPlus, WandSparkles } from "lucide-react";
import { useRouter } from "next/navigation";
import { useCallback, useEffect } from "react";
const modeOptions: ToggleOption<"manual" | "preference">[] = [{
  value: "manual",
  label: "Search",
  icon: <ListFilterPlus className="w-3.5 h-3.5" style={{
    strokeWidth: 2
  }} />
}, {
  value: "preference",
  label: "Preferences",
  icon: <WandSparkles className="w-3.5 h-3.5" style={{
    strokeWidth: 2
  }} />
}];
interface SearchModeToggleProps {
  onModeChange?: (mode: "manual" | "preference") => void;
}
export function SearchModeToggle(t0) {
  const $ = _c(11);
  const {
    onModeChange
  } = t0;
  const {
    mode: activeMode,
    setMode,
    initializeFromUrl
  } = useSearchMode();
  const currentCity = useCurrentCityName();
  const router = useRouter();
  let t1;
  let t2;
  if ($[0] !== initializeFromUrl) {
    t1 = () => {
      initializeFromUrl();
    };
    t2 = [initializeFromUrl];
    $[0] = initializeFromUrl;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== currentCity || $[4] !== onModeChange || $[5] !== router || $[6] !== setMode) {
    t3 = newMode => {
      setMode(newMode);
      onModeChange?.(newMode);
      if (newMode === "preference") {
        router.push("/preference");
      } else {
        router.push(`/${currentCity}`);
      }
    };
    $[3] = currentCity;
    $[4] = onModeChange;
    $[5] = router;
    $[6] = setMode;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleModeChange = t3;
  let t4;
  if ($[8] !== activeMode || $[9] !== handleModeChange) {
    t4 = <ExpandableToggle options={modeOptions} value={activeMode} onChange={handleModeChange} switchCollapseDelay={1000} className="border-neutral-200 bg-white" />;
    $[8] = activeMode;
    $[9] = handleModeChange;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}